export const isKafkaEnabled =
  typeof process !== 'undefined' &&
  process.env.NEXT_PUBLIC_ENABLE_KAFKA === 'true'
